<template>
  <a-card :bordered="false" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row slot="title">
      <a-col :span="24" style="cursor: pointer;">
        <span @click="goBack">销售数据</span>>{{ cardName }}
      </a-col>
    </a-row>
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="购买人昵称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.buyMemberNickName" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="购买人号码" v-bind="searchItemLayout">
            <a-input v-model="queryParams.buyMemberMobile" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="购买日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
        </search-list>
      </search-header>
      <search-header :col="3">
        <search-list>
          <a-form-item label="激活人昵称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.activeMemberNickName" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="激活人号码" v-bind="searchItemLayout">
            <a-input v-model="queryParams.activeMemberMobile" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="激活日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateActiveChange" :value="selectedActiveDate" style="width: 100%"/>
          </a-form-item>
        </search-list>
      </search-header>
      <search-header :col="1">
        <search-list>
          <a-form-item style="margin-left: 2%;min-width: 310px;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
            <a-button @click="exportData">批量导出</a-button>
            <a-button @click="handleLook">查看已生成报表</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <a-row style="margin-bottom: 15px;">
      <a-col>在线购买地址：<a @click="openUrlDialog">点此查看</a></a-col>
    </a-row>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="nickNameSlots" slot-scope="data">
        {{ data.text }}<br/>{{ data.record.buyMemberNickMobile }}
      </div>
      <div slot="nameSlots" slot-scope="data">
        {{ data.text }}<br/>{{ data.record.activeMemberMobile }}
      </div>
      <span class="price-class" slot="priceSlots" slot-scope="data">￥{{ data.text }}</span>
      <div slot="action" slot-scope="data">
        <a @click="onOpenDeatil(data.record)">交易明细</a>
      </div>
    </custom-page-table>
    <a-modal title="在线购买地址" :visible="visible" :footer="null" @cancel="visible = false">
      <a-row style="margin-bottom: 15px;">
        <a-col :span="12">H5购买链接：</a-col>
        <a-col :span="12" class="text-r">
          <a-button type="primary" @click="onCopy">复制</a-button>
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 15px;">
        <a-textarea disabled v-model="linkUrl" :auto-size="{ minRows: 3, maxRows: 5 }"/>
      </a-row>
      <div class="lh20">H5购买二维码：</div>
      <QrCodeModule :type="3" :address="linkUrl"></QrCodeModule>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      title="交易记录"
      ref="pageList"
      :query-params="selectedQueryParams"
      :enableSearch="false"
      :requestPromise="loadPircePromise"
      row-key="logId"
      @close="showSelectedDialog=false"
      :columns="getPriceColumns()"
    >
      <span class="price-class" slot="priceSlots" slot-scope="data">
        <span>{{ data.text }}</span>
      </span>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import QrCodeModule from '@/views/platform/component/QrCodeModule'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import moment from 'moment'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'ElectronCardList',
  mixins: [searchForm],
  components: {
    QrCodeModule,
    SelectedProductDialog
  },
  data() {
    return {
      moment,
      selectedDate: undefined,
      selectedActiveDate: undefined,
      cardName: this.$route.query.cardName,
      visible: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      selectedQueryParams: {
        cardId: ''
      },
      showSelectedDialog: false,
      queryParams: {
        activeMemberMobile: '',
        activeMemberNickName: '',
        buyMemberMobile: '',
        buyMemberNickName: '',
        activeStartDay: '',
        activeEndDay: '',
        buyStartDay: '',
        buyEndDay: '',
        membershipCardId: ''
      },
      loadPromise: params => this.getListPromise(params),
      loadPircePromise: params => this.getPriceListPromise(params),
      columns: [
        {
          title: '卡号',
          dataIndex: 'id'
        },
        {
          title: '购买时间',
          dataIndex: 'createTime'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '120px'
        },
        {
          title: '支付流水号',
          dataIndex: 'payOrderNo',
          width: '150px'
        },
        {
          title: '购买人',
          dataIndex: 'buyMemberNickName',
          scopedSlots: { customRender: 'nickNameSlots' }
        },
        {
          title: '卡密',
          dataIndex: 'cardPassword',
          width: '100px'
        },
        {
          title: '激活时间',
          dataIndex: 'activeTime'
        },
        {
          title: '激活人',
          dataIndex: 'activeMemberNickName',
          scopedSlots: { customRender: 'nameSlots' }
        },
        {
          title: '金额(元)',
          dataIndex: 'denomination'
        },
        {
          title: '剩余金额(元)',
          dataIndex: 'ableMoney'
        },
        {
          title: '有效期',
          dataIndex: 'validityValue',
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      selectedDateTime: '',
      linkUrl: ''
    }
  },
  mounted() {
  },
  activated() {
    this.queryParams.membershipCardId = this.$route.query.cardId
    this.cardName = this.$route.query.cardName
    this.$refs.table.refresh(true)
  },
  deactivated() {
    this.queryParams = {
      activeMemberMobile: '',
      activeMemberNickName: '',
      buyMemberMobile: '',
      buyMemberNickName: '',
      activeStartDay: '',
      activeEndDay: '',
      buyStartDay: '',
      buyEndDay: '',
      membershipCardId: ''
    }
  },
  watch: {
    // 'selectedQueryParams.cardId': function(newVal, oldVal) {
    //   this.$nextTick(()=>{
    //     if(oldVal&&oldVal!=""){
    //       this.$refs.pageList.refresh(true);
    //     }
    //   })
    // }
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      if (params.membershipCardId) {
        this.queryParams = params
        return this.getHttpServices().getUserService().post('member/v2/card/getElectronicSaleData', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.buyStartDay = dateStrArr[0]//购买开始日期
      this.queryParams.buyEndDay = dateStrArr[1]//购买结束日期
    },
    onDateActiveChange(dates, dateStrArr) {
      this.selectedActiveDate = dates
      this.queryParams.activeStartDay = dateStrArr[0]//激活开始日期
      this.queryParams.activeEndDay = dateStrArr[1]//激活结束日期
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    onOpenDeatil(record) {
      this.getLogUtils().logWithTag('==getListPromise==', record)
      this.showSelectedDialog = true
      this.selectedQueryParams.cardId = record.id
      this.$nextTick(() => {
        this.$refs.pageList.refresh(true)
      })
    },
    // 订单导出
    exportData() {
      this.searchBtn()
      this.getLogUtils().logWithTag('==getListPromise==', this.queryParams)
      this.getHttpServices().getUserService().post('member/v2/card/electronicCardExport', this.queryParams).then(res => {
        this.$message.success('批量导出成功，请去报表中心下载')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 查看已生产报表
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    openUrlDialog() {
      this.visible = true
      let domainUrl = this.getAppConfig().platformConfig.h5Url
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      let params = {
        p: `${character}_${merchantId}_${merchantId}`,
        cardId: this.$route.query.cardId
      }
      this.linkUrl = RouterSwitchHelper.getMemberCardBuyPathUrl(domainUrl, params)
    },
    //表格数据
    getPriceListPromise(params) {
      if (params.cardId) {
        return this.getHttpServices().getOrderService().post('order/membership/query/transaction/order', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    },
    onCopy() {
      // get current settings from mixin or this.$store.state.app, pay attention to the property name
      this.$copyText(this.linkUrl).then(message => {
        this.getLogUtils().logWithTag('copy', message)
        this.$message.success('复制完毕')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    },
    getPriceColumns() {
      return [
        {
          title: '类型',
          dataIndex: 'logOrderTypeStr'
        },
        {
          title: '时间',
          dataIndex: 'logTransactionTime'
        },
        {
          title: '金额',
          dataIndex: 'logOrderAmountStr',
          scopedSlots: { customRender: 'priceSlots' }
        },
        {
          title: '订单号',
          dataIndex: 'logOrderNo'
        },
        {
          title: '所属店铺',
          dataIndex: 'logShopName'
        }
      ]
    }
  }

}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.text-r {
  text-align: right;
}

.lh20 {
  line-height: 20px;
  margin-bottom: 15px;
}
</style>